export default "__VITE_ASSET__Cu2b53eZ__"